import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { isElectron } from "../utils/electronEnv";

const GA_MEASUREMENT_ID = "G-Q7TPDTQZCZ";

/**
 * Sends a GA4 page_view on client-side route changes.
 * The initial pageview is already sent by the gtag snippet in index.html.
 */
export default function GoogleAnalytics() {
  const location = useLocation();
  const isFirstLoad = useRef(true);

  useEffect(() => {
    if (isElectron()) return;
    if (typeof window.gtag !== "function") return;

    if (isFirstLoad.current) {
      isFirstLoad.current = false;
      return;
    }

    window.gtag("event", "page_view", {
      send_to: GA_MEASUREMENT_ID,
      page_title: document.title,
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}`,
    });
  }, [location.pathname, location.search]);

  return null;
}
